function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m28 10c.553 0 1 .447 1 1v18c0 .553-.447 1-1 1s-1-.447-1-1v-18c0-.553.447-1 1-1zm-4.004 10.998c.552 0 1.003.452 1.003 1.004v2.993c0 .552-.451 1.003-1.003 1.003h-7.993c-.552 0-1.003-.451-1.003-1.003v-2.993c0-.552.451-1.004 1.003-1.004zm.003-7c.55 0 1 .45 1 1v3.001c0 .55-.45.999-1 .999h-11.999c-.55 0-1-.449-1-.999v-3.001c0-.55.45-1 1-1z",
  fillRule: "evenodd",
  transform: "translate(-11 -10)"
});

var SvgAlignRight = function SvgAlignRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 18 20",
    width: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlignRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/align-right.b8e8b2e3.svg";
export { ForwardRef as ReactComponent };